export default "__VITE_ASSET__BWgAD1Yi__"